<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-list v-if="props.roles.length && props.selected" class="user-roles-list overflow-y-auto">
    <v-list-item
      v-for="(userRole, index) in props.roles"
      :id="`userRole-${index}`"
      :key="`${userRole.id}-${index}`"
      dense
      height="30px"
      dark
    >
      <div :class="`${listItemClass(userRole)}`">
        <button :id="`userRole-${index}-btn`" :class="`user-role-name `" @click="updateSelected(userRole)">
          {{ userRole.displayName }}
        </button>
      </div>
    </v-list-item>
  </v-list>
</template>
<script setup lang="ts">
import { UserRole } from '@/store/modules/userRoles/types';

const props = defineProps({
  selected: {
    type: Object,
    default: () => ({})
  },
  roles: {
    type: Array,
    default: () => ([])
  }
});

const emit = defineEmits(['selected-role-changed']);

function updateSelected(newlyselected: UserRole) {
  emit('selected-role-changed', newlyselected);
}

function listItemClass(name: UserRole) {
  return props.selected && props.selected.id === name.id ? 'user-role-item-selected' : 'user-role-item';
}

</script>
<style lang="scss" scoped>
@import './styles/list.scss';
</style>
